import { render, staticRenderFns } from "./tooltip-modal.vue?vue&type=template&id=1ffd9702&scoped=true"
import script from "./tooltip-modal.vue?vue&type=script&lang=js"
export * from "./tooltip-modal.vue?vue&type=script&lang=js"
import style0 from "./tooltip-modal.vue?vue&type=style&index=0&id=1ffd9702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd9702",
  null
  
)

export default component.exports